<button
  *ngIf="hasChild"
  mat-icon-button
  [attr.aria-label]="'Toggle ' + node.name"
  (click)="treeControl.toggle(node)"
>
  <mat-icon
    [svgIcon]="
      treeControl.isExpanded(node) ? 'mat:expand_more' : 'mat:chevron_right'
    "
  ></mat-icon>
</button>

<button *ngIf="!hasChild" mat-icon-button disabled></button>

{{ node.name }}
